import { TableDataApiParams } from '@services/practices.service';
import { DataSourceBaseNew } from '@components/new-table/data-source-base-new.dataSource';
import { TestDriveModel } from '@/models/test-drive/test-drive.model';
import { TestDriveService } from '@services/test-drive.service';

export class DataSourceTestDriveTable extends DataSourceBaseNew<TestDriveModel> {
  constructor(private testDriveService: TestDriveService) {
    super();
  }

  loadData(params?: TableDataApiParams): void {
    this._isLoading$.next(true);

    this.testDriveService.getDataForTable(params).subscribe((data) => {
      this.elements$.next(data.content);
      this._totalElements$.next(data.totalElements);
      this._isLoading$.next(false);
    });
  }
}
